export default class userSettings {
    constructor() {
        return {
            restrict: 'E',
            template: require('../../../../views/setting/partials/user-settings.html'),
            controller: UserSettingsCtrl,
            controllerAs: 'user'
        }
    }
};

class UserSettingsCtrl {
    constructor($scope, $filter, Setting, Translate, Events, Account) {
        this._scope = $scope;
        this._translator = $filter('translate');
        
        this.settingsRepo = Setting;
        this.translateRepo = Translate;
        this.accountRepo = Account;
        this.eventHandler = Events;

        this.showLanguage = true;
        this.showPassword = true;
        this.showNotifications = false;

        this.settingsRepo.getLanguage().then((result) => {
            this.language = Translate.isAvailableLanguage(result.language)? result.language : 'en';
        });

        this.accountRepo.me().then((response) => {
            this.disabledPassword = response.data.disabledPassword;
        });

        this.languages = Translate.getAvailableLanguages();
    }


    toggleLanguage() {
        this.showLanguage = ! this.showLanguage;
    };

    togglePassword() {
        this.showPassword = ! this.showPassword;
    };

    toggleNotifications() {
        this.showNotifications = ! this.showNotifications;
    };

    changeLanguage(key) {
        this.translateRepo.useLanguage(key);
    
        this.settingsRepo.setLanguage(key).then(() => {
            this.eventHandler.flashEvent('notification', this._translator('SETTING:FLASH:ADDED_LANGUAGE_MESSAGE'));
            this._scope.$emit('event:beacon.reInit');
        }, () => {
            this.eventHandler.flashEvent('error', this._translator('SETTING:FLASH:ADDED_LANGUAGE_ERROR_MESSAGE'));
        })
    };

    changeUserPassword() {
        if (! this.oldPassword || ! this.newPassword) {
            return this.eventHandler.flashEvent('error', this._translator('SETTING:FLASH:PASSWORD_EMPTY'));
        }
    
        if (this.oldPassword.length > 0 && this.newPassword.length > 0) {
            this.settingsRepo.changeUserPassword(this.oldPassword, this.newPassword).then(() => {
                this.eventHandler.flashEvent('notification', this._translator('SETTING:FLASH:PASSWORD_CHANGED'));
            }, (err) => {
                const errors = err.data.errors;
                const message = errors ? Object.values(errors)[0][0] : this._translator('GLOBAL:ERROR:DEFAULT');
                this.eventHandler.flashEvent('error', message);
            });
        }
    };
}
